import { ReactElement } from 'react';
import { useRoutes, Link } from 'react-router-dom';
import { CreateScene, DeleteScene, EntityScene, ModelScene, IndexScene, UpdateScene, useEntity } from 'components';
import permissions from '../permissions';
import { DepartmentFactor, FactorRateBadge } from 'modules/supplier/factors';
import { Form } from './Form';
import { Box, TableColumns } from '@ff-it/ui';
import { clampLine } from 'styles/style.css';

const columns: TableColumns<DepartmentFactor> = [
  {
    content: 'Type',
    key: 'type',
    sortable: true,
    width: 100,
  },
  {
    content: 'Name',
    key: 'name',
    sortable: true,
    render: ({ id, name }: DepartmentFactor) => <Link to={`${id}`}>{name}</Link>,
  },
  {
    content: 'Description',
    key: 'description',
    render: ({ description }) => <Box className={clampLine}>{description}</Box>,
  },
  {
    content: 'Kind',
    key: 'kind',
    width: 100,
  },
  {
    content: 'Rate',
    key: 'rate',
    width: 100,
    cellProps: {
      textAlign: 'right',
    },
    render: (factor) => <FactorRateBadge factor={factor} />,
  },
];

const initialValues = {
  type: null,
  name: '',
  description: '',
  kind: 'CONSTANT',
  rate: null,
  rates: null,
};

export function Factors(): ReactElement {
  const {
    item: { id: departmentId },
  } = useEntity();

  const routes = useRoutes([
    { index: true, element: <IndexScene columns={columns} /> },
    {
      path: 'create',
      element: (
        <CreateScene initialValues={initialValues}>
          <Form create />
        </CreateScene>
      ),
    },
    {
      path: ':id/',
      element: <EntityScene />,
      children: [
        {
          index: true,
          element: (
            <UpdateScene>
              <Form create={false} />
            </UpdateScene>
          ),
        },

        {
          path: 'delete',
          element: <DeleteScene />,
        },
      ],
    },
  ]);
  return (
    <ModelScene
      endpoint={`supplier/departments/${departmentId}/factors/`}
      title="Factor"
      pluralTitle="Factors"
      entityTitle={({ name }: DepartmentFactor) => name}
      permissions={permissions}
    >
      {routes}
    </ModelScene>
  );
}
